import Cell from "./Cell";
import Element from "./Element";
import ScrollElement from "./ScrollElement";
import Header from "./Header";
import { Root } from "./Root";
import Body from "./Body";
import Row from "./Row";

export const Table = {
    Root: Root,
    Element: Element,
    ScrollElement: ScrollElement,
    Header: Header,
    Body: Body,
    Row: Row,
    Cell: Cell,
}